import styled from 'styled-components';
import { View } from '../Basic/View/view';
import * as Select from '@radix-ui/react-select';
import { Z_INDEX } from '../../constants/zIndex';

interface Props {
  full?: boolean;
  color?: string;
  textColor?: string;
  insideModal?: boolean;
}

export const SelectTrigger = styled(Select.Trigger) <Props>`
  margin-top:12px;
  all: unset;
  width: ${({ full }) => (full ? '100%' : 'fit-content')};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1;
  height: 35px;
  gap: 5px;
  background-color: ${props => props.theme.colors.card_300};
  color: ${props => props.theme.colors.primary};
  border: 1px solid;
  border-color: ${props => props.theme.colors.primary};
  padding-inline: ${({ full }) => (full ? 0 : '20px')};
  
  -webkit-box-shadow: 0 0 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: ${props => props.theme.colors.hover};
  }

  &:focus {
    box-shadow: 0 0 0 2px black;
  }

  &[data-placeholder] {
    color: ${props => props.theme.colors.primary};
  }
`;


export const SelectHeader = styled(View)`
  display:flex;
  align-items: baseline;
  justify-content: space-between;
  flex-direction: column;
  margin-bottom: 10px
`;

export const SelectIcon = styled(Select.Icon)`
  color: ${props => props.theme.colors.primary}
`;

export const SelectContent = styled(Select.Content) <Props>`
  overflow: hidden;
  background-color: ${props => props.theme.colors.card};
  border-radius: 6px;
  box-shadow: 0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2);
  z-index: ${props => props.insideModal ? Z_INDEX.MODAL_CONTENT + 1 : Z_INDEX.DROPDOWN};
`;

export const SelectViewport = styled(Select.Viewport)`
  padding: 5px;
`;

export const SelectLabel = styled(Select.Label)`
  padding: 0 25px;
  font-size: 12px;
  line-height: 25px;
  color: red;
`;

export const SelectItem = styled(Select.Item) <Props>`
  background-color: ${props => props.color};
  font-size: 13px;
  line-height: 1;
  color: ${props => props.textColor};
  border-radius: 3px;
  display: flex;
  align-items: center;
  height: 25px;
  padding: 0 35px 0 25px;
  position: relative;
  user-select: none;

  &[data-disabled] {
    color: var(--mauve-8);
    pointer-events: none;
  }

  &[data-highlighted] {
    outline: none;
    background-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.white};
  }
`;

export const SelectItemIndicator = styled(Select.ItemIndicator)`
  position: absolute;
  left: 0;
  width: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const SelectScrollButton = styled(Select.ScrollUpButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  background-color: white;
  color: ${props => props.theme.colors.primary};
  cursor: default;
`;

export const SelectSeparator = styled(Select.Separator)`
  height: 1px;
  background-color: ${props => props.theme.colors.primary};
  margin: 5px;
`;

export const SelectItemText = styled(Select.ItemText)`
  color: ${props => props.theme.colors.primary};
`;

export const SelectScrollUpButton = styled(SelectScrollButton)`
`;
export const SelectScrollDownButton = styled(SelectScrollButton)`
`;



//CheckBox
export const CheckRoot = styled.div`
  background-color:"red";
  position:relative
  
`;

export const CheckHead = styled("div") <Props>`
  all: unset;
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1;
  height: 35px;
  gap: 5px;
  background-color: ${props => props.theme.colors.card_300};
  color: ${props => props.theme.colors.primary};
  border: 1px solid;
  border-color: ${props => props.theme.colors.primary};

  
  -webkit-box-shadow: 0 0 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: ${props => props.theme.colors.hover};
  }

  &:focus {
    box-shadow: 0 0 0 2px black;
  }

  &[data-placeholder] {
    color: ${props => props.theme.colors.primary};
  }
`;

export const CheckTitle = styled.div`
  padding: 5px;
`;

export const CheckViewport = styled("div") <Props>`
  overflow:scroll;
  max-height:60vh;
  position: absolute;
  clip: rect(0px, 0px, 0px, 0px);
  border: 0px;
  width: ${({ full }) => (full ? '100%' : 'fit-content')};
  height: 1px;
  padding: 10px;
  margin: -1px;
  white-space: nowrap;
  background-color: white;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  font-size: 13px;
  height: auto;
  background-color: #FFFFFF;
  color: #3A94E8;
  padding-inline: 20px;
  display: block;
  z-index: ${Z_INDEX.DROPDOWN};
  
  box-shadow: 0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2);
`;

export const CheckGroup = styled.div`
  padding: 5px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ValuePlaceHolder = styled.div`
  color: ${props => props.theme.colors.text}; 
`;